<div class="image-tile"
     [ngClass]="{'image-tile--full-width': fullWidth}">
  <div class="image-tile__content">
    <div class="image-tile__header it-header">
      <ng-container *ngIf="isExternalLink(link)">
        <a class="it-header__link"
           [href]="link"
           [target]="openInNewTab ? '_blank' : '_self'"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="headline"></ng-container>
        </a>
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <a *ngIf="ad"
           class="it-ad"
           [href]="link"
           [target]="openInNewTab ? '_blank' : '_self'"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="adbadge"></ng-container>
        </a>
        <a class="it-background"
           [href]="link"
           [target]="openInNewTab ? '_blank' : '_self'"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="background"></ng-container>
        </a>
      </ng-container>
      <ng-container *ngIf="!isExternalLink(link)">
        <a class="it-header__link"
           [routerLink]="link"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="headline"></ng-container>
        </a>
        <ng-container *ngTemplateOutlet="content"></ng-container>
        <a *ngIf="ad"
           class="it-ad"
           [routerLink]="link"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="adbadge"></ng-container>
        </a>
        <a class="it-background"
           [routerLink]="link"
           [attr.data-gtm-event-category]="gtmEventCategory"
           [attr.data-gtm-event-action]="gtmEventAction"
           [attr.data-gtm-event-label]="gtmEventLabel">
          <ng-container *ngTemplateOutlet="background"></ng-container>
        </a>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #headline>
  <h2 class="it-header__headline"
      [innerHTML]="nameNlToBr">{{ name }}</h2>
</ng-template>

<ng-template #content>
  <ng-content select="[content]"></ng-content>
</ng-template>

<ng-template #adbadge>
  <p1-lib-ui-elements-badge-ad [dark]="true"></p1-lib-ui-elements-badge-ad>
</ng-template>

<ng-template #background>
  <div class="it-background__picture">
    <p1-lib-ui-elements-picture *ngIf="imageUuid && !fullWidth"
                                [fileId]="imageUuid"
                                [pictureData]="[
                                                 { viewportWidth: 1088, width: 438, height: 247, mode: imageMode.crop },
                                                 { viewportWidth: 832, width: 334, height: 187, mode: imageMode.crop },
                                                 { viewportWidth: 576, width: 384, height: 216, mode: imageMode.crop },
                                                 { viewportWidth: 448, width: 538, height: 303, mode: imageMode.crop }
                                               ]"
                                [imageData]="{
                                               width: 410,
                                               height: 230,
                                               mode: imageMode.crop,
                                               alt: nameStrippedNl,
                                               lazy: true
                                             }">
    </p1-lib-ui-elements-picture>

    <p1-lib-ui-elements-picture *ngIf="imageUuid && fullWidth"
                                [fileId]="imageUuid"
                                [pictureData]="[
                                                 { viewportWidth: 1088, width: 1140, height: 208, mode: imageMode.crop },
                                                 { viewportWidth: 968, width: 1045, height: 189, mode: imageMode.crop },
                                                 { viewportWidth: 752, width: 935, height: 256, mode: imageMode.crop },
                                                 { viewportWidth: 448, width: 717, height: 403, mode: imageMode.crop }
                                               ]"
                                [imageData]="{
                                               width: 1140,
                                               height: 208,
                                               mode: imageMode.crop,
                                               alt: nameStrippedNl,
                                               lazy: true
                                             }">
    </p1-lib-ui-elements-picture>

  </div>
</ng-template>
